/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModuleSettingsInput } from './courseModuleSettingsInput';

/**
 * update course module request
 */
export interface CourseModuleUpdateRequest {
  courseSettings: CourseModuleSettingsInput;
}
